<template>
  <div
    @click="navto"
    target="_blank"
    :to="{ path: '/knowingdetail', query: { id: obj.id } }"
    class="wrap"
  >
    <div class="tag"></div>
    <div class="wrap-content">
      <div class="title">
        {{ obj.title }}
      </div>
      <div class="intro">
        {{ obj.intro }}
      </div>
    </div>
    <div class="wrap-icons">
      <div class="icons-item">
        <i class="iconfont icon-good"></i>
        <span>{{ obj.mark | formatUnit }}</span>
      </div>
      <div class="icons-item">
        <i class="iconfont icon-yanjing"></i>
        <span>{{ obj.views | formatUnit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navto(){
      this.$emit('tab',{})
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrap {
  @theme-color: #3370ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 40px;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  .tag {
    margin-top: 5px;
    margin-right: 40px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: @theme-color;
    align-self: flex-start;
  }
  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 15px;
      color: @theme-color;
      // height: 15px;
      // line-height: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .intro {
      font-size: 12px;
      margin-top: 20px;
      color: #999999;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  &-icons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 40px;
    // width: 100px;
    min-width: 200px;
    .icons-item {
      margin-right: 30px;
      color: #999999;
      span{
        font-size: 12px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/knowledgeItem.vue